import React, { useEffect, useState } from 'react';
import { db, doc, getDoc, setDoc } from '../services/firebase';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LEGAL_DOC_ID = 'legalPagesContent';
const LEGAL_FIELDS = [
  { key: 'terms', label: 'Terms of Service' },
  { key: 'privacy', label: 'Privacy Policy' },
  { key: 'shipping', label: 'Shipping Policy' },
  { key: 'refund', label: 'Refund Policy' },
  { key: 'contact', label: 'Contact Information' },
];

const AdminLegalManagement = () => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true);
      try {
        const docRef = doc(db, 'admin', LEGAL_DOC_ID);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setContent(docSnap.data());
        } else {
          setContent({});
        }
      } catch (err) {
        setMessage('Error loading legal content.');
      }
      setLoading(false);
    };
    fetchContent();
  }, []);

  const handleChange = (key, value) => {
    setContent((prev) => ({ ...prev, [key]: value }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');
    try {
      const docRef = doc(db, 'admin', LEGAL_DOC_ID);
      await setDoc(docRef, content);
      setMessage('Legal content updated successfully!');
    } catch (err) {
      setMessage('Error saving legal content.');
    }
    setSaving(false);
  };

  return (
    <div style={{ background: '#f8fafc', minHeight: '100vh' }}>
      <Header />
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 0' }}>
        <h2 style={{ textAlign: 'center', fontWeight: 900, fontSize: 32, marginBottom: 32 }}>Legal Management</h2>
        <form onSubmit={handleSave} style={{ background: '#fff', borderRadius: 10, boxShadow: '0 4px 18px rgba(0,0,0,0.08)', padding: 32 }}>
          {LEGAL_FIELDS.map(({ key, label }) => (
            <div key={key} style={{ marginBottom: 28 }}>
              <label style={{ fontWeight: 700, fontSize: 18, display: 'block', marginBottom: 8 }}>{label}</label>
              <textarea
                value={content[key] || ''}
                onChange={e => handleChange(key, e.target.value)}
                rows={7}
                style={{ width: '100%', fontSize: 16, padding: 12, borderRadius: 6, border: '1px solid #ccc', resize: 'vertical' }}
                disabled={loading}
              />
            </div>
          ))}
          <button type="submit" disabled={saving || loading} style={{ padding: '10px 32px', fontSize: 18, borderRadius: 8, background: '#222', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 700 }}>
            {saving ? 'Saving...' : 'Save'}
          </button>
          {message && <div style={{ marginTop: 18, color: message.includes('success') ? 'green' : 'red', fontWeight: 600 }}>{message}</div>}
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default AdminLegalManagement; 